module.exports = __webpack_public_path__ + "static/media/video-en.06637761.png";